import React from "react";

function FAQ(){

    return(
        <div>
            <div className="main">
                <h1 style={{"textAlign": "center"}}>Frequently Asked Questions</h1>

                <h2 style={{"textAlign": "center"}}>General Questions</h2>
                <h3>What is Crypto Wave Jade Corals?</h3>
                <p>Crypto Wave Jade Corals or CWJC is a mediating token between excellent traders and  BUSD owners. It enables a 
                    crypto trader knowledgeable in technical and fundamental analysis to start an asset management. On the other hand, 
                    it gives BUSD owners an opportunity to trade while leveraging with the professional traders and 
                    with insurance coverage for losses to minimize trading risk in a volatile crypto market.<br/><br/>

                    Note: Kindly review your laws and regulations, if you are permitted to use this platform.
                </p><br />

                <h3>What is privileged CWJC minting/burning?</h3>
                <p>This entitles a wallet to a 67% CWJC minting/burning discount. In other words, fee will become 1% instead of 3%.</p><br/>

                <h3>Who are eligible to CWJC minting/burning privilege?</h3>
                <p>Those who have active Cake Monster Diamond Claw NFT (DCNFT).</p><br/>
                <p>Note: DCNFT is a different project whose team is not related to CWJC team.</p><br/>

                <h3>What is the amount of allocation an active DCNFT holder can get?</h3>
                <p>It depends on the level (Figures are subject to change).<br/>
                    1. Level 1 -   300.00.<br/>
                    2. Level 2 -   600.00.<br/>
                    3. Level 3 - 1,200.00.<br/>
                    4. Level 4 - 1,800.00.<br/>
                    5. Level 5 - 2,400.00.<br/>
                </p><br/>

                <h3>What is the frequency of requesting allocation?</h3>
                <p>Weekly.</p><br/>

                <h3>Is there a fee for requesting allocation?</h3>
                <p>Yes. A nominal amount of 0.10% in busd of allocation requested.</p><br/>

                <h3>Can I change my registered DCNFT?</h3>
                <p>Yes.</p><br/>

                <h3>How to activate DCNFT?</h3>
                <p>It depends on the level.<br/>
                    1. Level 1 - hold at least 0.0125% of monsta supply.<br/>
                    2. Level 2 - hold at least 0.0250% of monsta supply.<br/>
                    3. Level 3 - hold at least 0.0500% of monsta supply.<br/>
                    4. Level 4 - hold at least 0.0750% of monsta supply.<br/>
                    5. Level 5 - hold at least 0.1000% of monsta supply.<br/><br/>

                    Note: Cake Monster or monsta is a different project whose team is not related to CWJC team. Ownership of monsta 
                    requires regular wallet resetting every 50 days. This requires sale/buy/transfer of at least 5.01% before end of 
                    50 days to prevent inactivity tax.<br/>
                </p><br/>

                <h3>What are the fees involved in CWJC environment?</h3>
                <p>1.  3.00% for regular minting fee. (1% for Global Reserve, 1% for Global Insurance & 1% for Treasury) <br />
                2.  3.00% for regular burning fee. (1% for Global Reserve, 1% for Global Insurance & 1% for Treasury) <br />
                3.  1.00% for privileged minting/burning fee. (1% for Treasury) <br />
                4.  0.10% for privileged allocation fee. <br />
                5.  5.00% for sales commission for redeeming Insurance. <br />
                5.  0.50% for sCTMT staking/unstaking fee. <br />

                </p><br />                

                <h2 style={{"textAlign": "center"}}>Fund Provider</h2>
                <h3>How to provide funds to Trading Manager?</h3>
                <p>1. Buy/Mint CWJC <i>(1 BUSD per CWJC less 1% to 3% fees)</i><br/> 
                2. Register as Trading Manager for 1 CWJC.<br />
                3. Choose a manager to support. <br/>
                4. Burn CWJC to permit the protocol to provide the trading manager with BUSD. One (1) MFWP costs one (1) CWJC.<br />
                5. Wait manager to declare dividends. When unrealized profit reached at least 20%, you can also declare it. Fifty per
                centum of profit will be distributed to supporter proportionately.<br />
                6. As supplier of MFWP to a particular beach, salt miner are allowed to filter as much salt as they want until closure 
                of the beach.
                </p><br />

                <h3>What is Mountain Fresh Water Pipes (MFWP)?</h3>
                <p>A token to be received in exchanged for burning CWJC for supporting trade managers. This is used for: <br/>
                1. Collecting CWJC from profit declaration of tradeing managers. <br/>
                2. Exchanging insurance in SSGS & SSSS token. <br/>
                3. It is also saleable in the secondary market (PCS).</p><br/> 

                <h3>How to evaluate risk of a particular trader?</h3>
                <p>The following indicators are useful in analyzing and sellecting risk of a particular trader:<br/> 
                1. <b><i>Token For Trade</i></b> - the type of token/coin used to be traded.<br/>
                2. <b><i>Age in Days</i></b> - number of days the manager started traded.<br/>
                3. <b><i>Base BUSD</i></b> - the minimum amount of BUSD to make a profit.<br/>    
                4. <b><i>CWJC Returned</i></b> - amount of CWJC already returned by the manager.<br/> 
                5. <b><i>Unrealized Profit or (Loss)</i></b> - the current trading status (if profit or loss) of the manager.<br/>   
                6. <b><i>CWJC Return Rate</i></b> - rate of profit or loss of the holdings.<br/> 
                7. <b><i>Local Insurance Coverage Rate</i></b> - the capacity of local insurance to cover losses by fund providers. <br/> 
                8. <b><i>Global Reserve Coverage Rate</i></b> - the capacity of local reserve to cover losses by fund managers.<br/> 
                                                              
                </p><br />                               

                <h3>Can I change my manager?</h3>
                <p>No. You cannot change manager but you can quit after 180 days.
                </p>

                <h3>How much CWJC I am entitled for supporting a manager?</h3>
                <p>Fifty per centum (50%) of profit declared is alloted for buying back MFWP proportionate to the total support 
                    received by the manager. After buying back all MWFP, as a gratuity for support, suppoerters will receive free CWJC.</p><br/> 

                <h3>What is the exchange rate of MWFP?</h3>
                <p>Each MWFP is equivalent to 1 SSGS or 1 SSSS.</p><br/>                     

                <h3>As a supporter, until when I will receive free CWJC?</h3>
                <p>As long as the manager is operating.</p><br /> 

                <h3>When can I quit supporting the manager?</h3>
                <p>Yes. After 180 days.</p><br/>  

                <h3>What will happen to my minted and remaining MFWP if I quit?</h3>
                <p>You will be receiving insurance in SSGS (Sea Shore Golden Sand) & SSSS (Sea Shore Silver Sand) tokens.</p><br/>  

                <h3>What is the difference of SSGS & SSSS tokens?</h3>
                <p>Each SSGS is fully funded by one (1) CWJC token while SSSS maybe fully or partially funded depending on the 
                    accumulated reserve for Global Insurance or SSGS.</p><br/>  

                <h3>Up to how many SSGS I am qualified to received?</h3>
                <p>Proportionate amount based on minted and existing MFWP relative MFWP not yet returned by the manager.</p><br/>  

                <h3>How much is the valuation of SSGS and SSSS?</h3>
                <p>One (1) Sea Shore Golden Sand (SSGS) is equal to one (1) CWJC less 5.00% insurance fee. However, Sea Shore Silver Sand (SSSS) has a 
                    variable price which will not exceed 1 CWJC each subject to 5.00% insurance fee.</p><br/> 

                <h3>When is the best to redeem insurance (SSGS or SSSS)?</h3>    
                <p>After 180 days.</p><br/>            

                <h3>Can I fredeem my insurance upon receipt or earlier?</h3>
                <p>Yes but will be charged with 30% insurance fee.</p><br/>                     

                <h2 style={{"textAlign": "center"}}>Trade Managers</h2>
                <h3>How to start an asset management?</h3>
                <p>1. Register as Trading Manager for 10 CWJC (first 100). <br />
                2. Choose crypto token/coin (btc, eth & wbnb) to manage and trade. <br />
                3. Get supports and receive BUSD from the protocol. <br />
                4. Trade your chosen token and make profit. <br />
                6. Declare profit when make more BUSD by at least 1% of the base BUSD. <br />
                7. Declare loss when BUSD balance falls below 5% of the base BUSD.<br />
                8. Redeem Global Reserve to recover trade losses. <br />
                9. Dissolve the holdings if it is not making profits. <br />

                </p><br/>                

                <h3>When can I declare profit??</h3>
                <p>Every time the BUSD value exceeded Base BUSD by at least 1%.</p><br/> 

                <h3>Where do the profit is allocated?</h3>
                <p>1. 10.00% for Trading Managers. <br />
                2.  50.00% for MWFP Buy Back and Burn.<br />
                3.  05.00% for Sea Shore Golden Sand Buy Back and Burn.<br />
                4.  05.00% for Sea Shore Silver Sand Buy Back and Burn.<br />
                5.  03.00% for Local Tading Loss Reserve.<br />
                6.  03.00% for Global Tading Loss Reserve.<br />
                7.  03.00% for Fund Growth (Added to Base BUSD).<br />
                8.  04.00% for Crypto Wave Diamond Pearls (CWDP) price boost.<br />
                9.  03.00% for partner tokens. (Currently allocated to CWDP) <br />
                10. 03.00% for partner tokens. (Currently allocated to CWDP) <br />
                </p><br />

                <h3>What is Tading Loss Reserve?</h3>
                <p>This is the amount used to reflenish BUSD losses made by trading managers. </p><br/>

                <h3>What is the difference of Local and Global Tading Loss Reserve?</h3>
                <p>Local reserve is fully funded BUSD while global reserve can be partially or fully funded. </p><br/>                

                <h3>Can I dissolve the holdings under my management?</h3>
                <p>Yes. The trading manager can dissolve the holdings anytime. In case of 5 years inactivity, the supporters can 
                    dissolve the holdings.</p><br/> 


            </div>
        </div>
        
    )
}

export default FAQ;